import { ACTIONS } from '../actions';

const INITIAL_STATE = {
  extensions: {},
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTIONS.INIT_DATA:
      state = action.payload.data;
      return state;
    default:
      return state;
  }
}
